(() => {
  function init() {
    const root = document.querySelector('[data-care-page="demi"],[data-care-page="soiree"]');
    if (!root || root.dataset.careReady) return;
    root.dataset.careReady = 'true';
    const care = root.querySelector('.care');
    care.classList.add('js');
    const buttons = Array.from(root.querySelectorAll('.care__material'));
    buttons.forEach(button => {
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      panel.hidden = true;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
        button.querySelector('.care__toggle').textContent = open ? '−' : '+';
      });
    });
    function showHash() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!id) return;
      const note = Array.from(root.querySelectorAll('.care__note')).find(x => x.id === id);
      if (!note) return;
      const button = buttons.find(x => x.getAttribute('aria-controls') === id);
      if (button && note.hidden) button.click();
      root.querySelector('#materials').scrollIntoView({block:'start'});
    }
    window.addEventListener('hashchange', showHash);
    document.fonts.ready.then(showHash);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
